module.exports = __webpack_public_path__ + "img/HM.e875a51e.svg";